module.exports = __webpack_public_path__ + "img/title-bg.a517e6e8.png";